export function Avatar() {
  return (
    <div className="flex size-10 flex-shrink-0 items-center justify-center rounded-full bg-indigo-500">
      A
    </div>
  )
}
